module.exports = __webpack_public_path__ + "img/Woo-logo-color.b4eb8d73.png";